import { InsuranceCompanyBatchStatus } from '../../../graphql/graphql';
import { INSURANCE_COMPANY_BATCH_TYPE_INVOICE } from './InsuranceCompanyBatchType.const';

export const INVOICE_BATCH_NOT_GENERATED = 'NOT_GENERATED' as const;

export type InsuranceCompanyBatchDisplayStatus =
	| InsuranceCompanyBatchStatus
	| typeof INVOICE_BATCH_NOT_GENERATED;

export const INSURANCE_COMPANY_BATCH_STATUS_LABEL: Record<
	InsuranceCompanyBatchDisplayStatus,
	string
> = {
	[InsuranceCompanyBatchStatus.Processing]:
		'component.insuranceCompanyBatch.batchStatus.processing',
	[InsuranceCompanyBatchStatus.Failed]:
		'component.insuranceCompanyBatch.batchStatus.failed',
	[InsuranceCompanyBatchStatus.Generated]:
		'component.insuranceCompanyBatch.batchStatus.generated',
	[InsuranceCompanyBatchStatus.Rejected]:
		'component.insuranceCompanyBatch.batchStatus.rejected',
	[InsuranceCompanyBatchStatus.Accepted]:
		'component.insuranceCompanyBatch.batchStatus.accepted',
	[INVOICE_BATCH_NOT_GENERATED]:
		'component.insuranceCompanyBatch.batchStatus.notGenerated',
};

export const INSURANCE_COMPANY_BATCH_STATUS_BADGE_CLASS: Record<
	InsuranceCompanyBatchDisplayStatus,
	string
> = {
	[InsuranceCompanyBatchStatus.Processing]: 'orange',
	[InsuranceCompanyBatchStatus.Failed]: 'red',
	[InsuranceCompanyBatchStatus.Generated]: 'green',
	[InsuranceCompanyBatchStatus.Rejected]: 'red',
	[InsuranceCompanyBatchStatus.Accepted]: 'green',
	[INVOICE_BATCH_NOT_GENERATED]: 'gray',
};

export const resolveInvoiceBatchDisplayStatus = (batch: {
	dtyp: string;
	childInvoiceBatch?: {
		batchStatus?: InsuranceCompanyBatchStatus | null;
	} | null;
}): InsuranceCompanyBatchDisplayStatus | null => {
	if (batch.dtyp === INSURANCE_COMPANY_BATCH_TYPE_INVOICE) {
		return null;
	}

	if (!batch.childInvoiceBatch) {
		return INVOICE_BATCH_NOT_GENERATED;
	}

	return batch.childInvoiceBatch.batchStatus ?? INVOICE_BATCH_NOT_GENERATED;
};
